module.exports = __webpack_public_path__ + "static/img/share-tip.e51591d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/share-tip.svg
// module id = 0QfV
// module chunks = 1